import { useAtomValue } from 'jotai';
import { renderedRadarDataAtom } from '@/atoms/radar';

export const useHasEmptyRadar = () => {
  const renderedRadarData = useAtomValue(renderedRadarDataAtom);
  return renderedRadarData.every(metric => metric.value === metric.minValue);
};
